import {OverlayTrigger, Tooltip} from "react-bootstrap";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

let myAbilities = HelpAbility();

function Item({i, error, setModalMessageShow, setModalDiagnosticoShow, setArrayProcesslog}){
 
 const handleMessage = () => {
    setArrayProcesslog([...error]);
    setModalMessageShow(true);
 }

 return (
   <tr>
      <th className="text-center" scope="row">{i + 1}</th>
      <td className="text-center">{error[0]}</td>
      <td className="text-center">{error[1]}</td>
      <td className="text-center">{error[2]}</td>
      <td className="text-center">{error[4]}</td>
      {myAbilities.hasAny([C.A.DEPARTAMENT.UPDATE, C.A.DEPARTAMENT.DELETE]) && <td className="d-flex align-items-center justify-content-center">
         {myAbilities.has(C.A.DEPARTAMENT.DELETE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Ver Mensaje</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-info me-2"
                      onClick={handleMessage}>
                  <i className="bi bi-info-lg"/>
              </button>
          </OverlayTrigger>}
      </td>}
  </tr>
 )
}
export default Item